import { render, staticRenderFns } from "./LeftNavSub.vue?vue&type=template&id=6f960d12&scoped=true"
import script from "./LeftNavSub.vue?vue&type=script&lang=js"
export * from "./LeftNavSub.vue?vue&type=script&lang=js"
import style0 from "./LeftNavSub.vue?vue&type=style&index=0&id=6f960d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f960d12",
  null
  
)

export default component.exports